import { HStack, Input, InputLeftElement, InputGroup } from '@chakra-ui/react';
import React from 'react';

import { colors } from 'packages/common-frontend/colors';
import { Icon } from 'packages/common-frontend/components/icons';
import { useArrangmentGroupUrlParam } from 'valleyBank/domains/ArrangementGroups/hooks/ArrangementGroupsContext';

export const ArrangementGroupSearch: React.FC<{}> = () => {
  const {
    arrangementGroupNumber,
    setArrangementGroupNumber,
  } = useArrangmentGroupUrlParam();
  const [search, setSearch] = React.useState(arrangementGroupNumber || '');

  return (
    <HStack
      w="100%"
      p="24px"
      spacing="24px"
      bgColor={colors.millet[100]}
      borderRadius="8px"
    >
      <InputGroup flexGrow={1} bgColor="white" borderRadius="8px">
        <InputLeftElement pointerEvents="none">
          <Icon icon="magnifying-glass" />
        </InputLeftElement>
        <Input
          placeholder="Search"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              setArrangementGroupNumber(search);
            }
          }}
        />
      </InputGroup>
    </HStack>
  );
};
